import React, { Component } from 'react'

import withCssClassName from '../with-css-class-name'

class AiqIcon extends Component {
    render() {
        return (
            <svg {...this.props} version="1" xmlns="http://www.w3.org/2000/svg" width="42.667" height="42.667" viewBox="0 0 32 32"><path d="M21.8 6.2l-.3 6.3-6.3 3.3L9 19.1l.2 6.7.2 6.7.3-6.3.4-6.3 6.4-3.1 6.5-3.2V6.8c0-8.5-.8-8.9-1.2-.6z"/><path d="M7.3 5.6c-.3.8-.1 2 .6 2.7.6.6 1.1 2.1 1.1 3.3 0 1.2.7 2.5 1.6 2.8 3 1.2 3.6.6 1.3-1.3-2.1-1.7-2.2-2.1-1-4.4.7-1.4 1-3 .7-3.6-1-1.6-3.6-1.3-4.3.5zM10 6c0 .5-.5 1-1.1 1-.5 0-.7-.5-.4-1 .3-.6.8-1 1.1-1 .2 0 .4.4.4 1z"/><path d="M15 7.5c-2.5 1.3-3.8 2.4-3 2.5 1.6 0 8-3.6 8-4.5 0-.7.1-.7-5 2zM14 10.5c-1.6.9-1.9 1.4-.9 1.5.8 0 2.4-.7 3.5-1.5 2.4-1.8.7-1.9-2.6 0zM17.7 11.6c-1.6.9-2.7 1.8-2.4 2 .7.7 5.7-1.8 5.7-2.8 0-1 .1-1-3.3.8zM19.8 18.7c2.2 1.6 3.1 5.3 1.1 5.3-.5 0-.7-.5-.4-1 .9-1.5-.1-1.2-4.6 1.1-2.3 1.1-3.9 2.3-3.6 2.5.3.3 1.9-.2 3.6-1 3.8-2 3.8-2 4.4.4.3 1.1 1.2 2 2.1 2 2.1 0 3.2-2.8 1.7-4.3-.6-.6-1.1-1.9-1.1-2.9 0-.9-.9-2.2-1.9-2.8-3-1.5-3.9-1.1-1.3.7z"/><path d="M12.9 20c-1.3 1-1.9 1.9-1.3 2 .7 0 2.2-.9 3.5-2 1.3-1 1.9-1.9 1.3-2-.7 0-2.2.9-3.5 2zM15.4 21.5c-2.4 1.8-.7 1.9 2.6 0 1.6-.9 1.9-1.4.9-1.5-.8 0-2.4.7-3.5 1.5z"/></svg>
        )
    }
}

export default withCssClassName(AiqIcon)



// WEBPACK FOOTER //
// src/components/svg-icon/icons/aiq-icon.js